import React from 'react';
import { useIntl } from 'umi';
import classNames from 'classnames';
import overLimitWarningIcon from '@/pages/dashboard/assets/svg/mid.svg';
import alertCloseWarningIcon from '@/pages/home/assets/teaStyle/static/alert-close-warning.12a402c7.svg';
import { formatLimitCount } from '@/pages/dashboard/components/OverLimitTip/utils';
import { DEFAULT_LIMIT_COUNT } from '@/pages/dashboard/components/OverLimitTip/constants';
import type { IOverLimitBarProps } from './type.d';

export const OverLimitBar: React.FC<IOverLimitBarProps> = ({
  className,
  style,
  limitCount,
  barLimitCount,
  overLimitTipFormatRule,
  barDownloadDisabled = true,
  onDownload,
  onDismiss,
  config,
}) => {
  const { formatMessage } = useIntl();
  const {
    prefixText = formatMessage({ id: 'dbd_over_limit_tip_prefix' }, { count: formatLimitCount(barLimitCount ?? limitCount ?? DEFAULT_LIMIT_COUNT, overLimitTipFormatRule) }),
    linkText = formatMessage({ id: 'dbd_over_limit_tip_link' }),
    suffixText = formatMessage({ id: 'dbd_over_limit_tip_suffix' }),
  } = config || {};

  return (
    <div className={classNames('dbd-over-limit-bar', className)} style={style}>
      <div className="dbd-over-limit-bar__left">
        <img className="dbd-over-limit-bar__icon" src={overLimitWarningIcon} alt="" />
        <span className="dbd-over-limit-bar__text">
          <span>{prefixText}</span>
          {' '}
          <span
            className={barDownloadDisabled ? 'dbd-over-limit-bar__link--disabled' : 'dbd-over-limit-bar__link'}
            onClick={barDownloadDisabled ? undefined : onDownload}
          >
            {linkText}
          </span>
          {' '}
          <span>{suffixText}</span>
        </span>
      </div>
      <img
        className="dbd-over-limit-bar__close"
        src={alertCloseWarningIcon}
        alt=""
        onClick={onDismiss}
      />
    </div>
  );
};

